module.exports = __webpack_public_path__ + "media/playing_single_line_5.7c1ab18d.mp3";